import { Box } from "@mui/material";
import { NavbarIcon } from "../atoms/navbar/Icon";
import { OrganizationSecret } from "../models/types";
import { TableTextWithEllipsis } from "./TableTextWithEllipsis";

type OrganizationSecretDisplayProps = {
  value: OrganizationSecret;
};

export const OrganizationSecretDisplay = ({ value }: OrganizationSecretDisplayProps) => (
  <Box display="flex" flexDirection="row" gap="5px" alignItems="center">
    <NavbarIcon
      variant="lock"
      sx={{
        minWidth: "18px",
        width: "18px",
        height: "18px",
        minHeight: "18px",
      }}
    />
    <TableTextWithEllipsis value={value.name} />
  </Box>
);
